export default "__VITE_ASSET__wPHOzHZn__"